"use strict";

export class OneTimeTrigger {
    constructor(callback) {
        this.triggered = false;
        this.callback = callback;
    }

    pull() {
        if (this.triggered) return;

        this.triggered = true;
        this.callback?.();
    }

    reset() {
        this.triggered = false;
    }
}